import { c as _c } from "react/compiler-runtime";
import { MoonIcon, SunIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useTheme } from 'next-themes';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { THEMES } from '@/constants/themes';
export function ThemeSwitcher() {
  const $ = _c(14);
  const {
    setTheme
  } = useTheme();
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("theme-toggle.toggle-theme");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SunIcon className="dark:hidden" />;
    t2 = <MoonIcon className="hidden dark:block" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0) {
    t3 = <DropdownMenuTrigger render={<Button variant="ghost" size="icon" aria-label={t0} data-testid="theme-toggle">{t1}{t2}</Button>} />;
    $[4] = t0;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== setTheme || $[7] !== t) {
    t4 = THEMES.map(theme => <DropdownMenuItem key={theme.value} onClick={() => {
      setTheme(theme.value);
    }} data-testid={`theme-option-${theme.value}`}>{theme.icon}{t(theme.labelKey)}</DropdownMenuItem>);
    $[6] = setTheme;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <DropdownMenuContent align="end" className="min-w-36">{t4}</DropdownMenuContent>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <DropdownMenu>{t3}{t5}</DropdownMenu>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}